import Iconify from "@/components/ui/Iconify";
import StaticVideoPreview from "@/components/ui/StaticVideoPreview";
import { useTranslations } from "@/lib/static-intl";
import Image from "next/image";
import { useState, useRef, useEffect } from "react";

const PDW_HomeClipSection = ({
  isCssForDialog,
  place,
  openFullScreenModal,
}) => {
  const t = useTranslations("places.place_details_window");
  const [media] = useState([
    ...(place?.placeMedia?.filter((_m) => _m?.mediaType?.includes("video")) ||
      []),
    ...((place?.postss)
      ?.map((post) => post?.media)
      ?.flat()
      ?.filter((_m) => _m?.mediaType?.includes("video")) || []),
  ]);

  const scrollRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const checkScrollable = () => {
      if (scrollRef.current) {
        const { scrollWidth, clientWidth } = scrollRef.current;
        setIsScrollable(scrollWidth > clientWidth);
      }
    };

    checkScrollable();

    window.addEventListener("resize", checkScrollable);
    return () => {
      window.removeEventListener("resize", checkScrollable);
    };
  }, [media]);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  if (media?.length === 0) return null;
  
  return (
    <div className="w-full flex flex-col gap-2 border-b dark:border-brown pb-4 relative">
      <span className="font-semibold text-lg dark:text-white">{t("clip")}</span>
      {media?.length > 0 ? (
        <>
          {isScrollable && (
            <>
              <button
                type="button"
                className="absolute top-1/2 right-2 bg-gray-300 dark:bg-heading_black text-black/80 dark:text-white/80 hover:text-black dark:hover:text-white border rounded-full z-10"
                onClick={scrollRight}
              >
                <Iconify
                  icon={"lsicon:right-filled"}
                  className={"!text-inherit !w-5 !h-5"}
                />
              </button>
              <button
                type="button"
                className="absolute top-1/2 left-2 bg-gray-300 dark:bg-heading_black text-black/80 dark:text-white/80 hover:text-black dark:hover:text-white border rounded-full z-10"
                onClick={scrollLeft}
              >
                <Iconify
                  icon={"lsicon:left-filled"}
                  className={"!text-inherit !w-5 !h-5"}
                />
              </button>
            </>
          )}
          <div
            ref={scrollRef}
            className="w-full max-w-full overflow-x-auto flex gap-2"
          >
            {media.map((mediaItem, index) => (
              <div
                key={index}
                className="relative rounded-xl overflow-hidden"
                onClick={openFullScreenModal}
              >
                <StaticVideoPreview
                  src={mediaItem?.filePath || "/sample-portrait.mp4"}
                  alt="media"
                  className={`${
                    isCssForDialog ? "h-[150px]" : "h-[250px]"
                  } object-cover rounded-xl max-w-[300px]`}
                />
                <div className="absolute cursor-pointer top-0 left-0 w-full h-full bg-black/0 hover:bg-black/20 transition ease-in-out duration-200" />
                {mediaItem?.mediaType?.includes("video") && (
                  <div className="absolute top-2 right-2 w-5 h-5 bg-black/10 backdrop-blur rounded-full z-10">
                    <Iconify
                      icon={"mynaui:play-solid"}
                      className={"!text-white"}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-2 items-center justify-center h-[300px]">
          <Image
            src={"/no-data.png"}
            alt="no-data"
            width={50}
            height={50}
            className="object-contain"
          />
          <span className="text-xs text-black/30 dark:text-white/30">
            {t("no clips")}
          </span>
        </div>
      )}
    </div>
  );
};

export default PDW_HomeClipSection;
